import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'catalogPage.hero.text': {
    id: 'catalogPage.hero.text',
    defaultMessage: 'Explore world-class learning \n Unmatched quality, market relevance, and comprehensive solutions.',
    description: 'Header text tagline.',
  },
  'catalogPage.hero.highlight': {
    id: 'catalogPage.hero.highlight',
    defaultMessage: 'Explore world-class learning',
    description: 'emphasized text of the header',
  },
  'catalogPage.catalogSelectionDeck.title': {
    id: 'catalogPage.catalogSelectionDeck.title',
    defaultMessage: 'Select a catalog',
    description: 'Title for catalog filters',
  },
});

export default messages;
